import { render, staticRenderFns } from "./AppSpinner.vue?vue&type=template&id=1a15c518&scoped=true&"
import script from "./AppSpinner.vue?vue&type=script&lang=js&"
export * from "./AppSpinner.vue?vue&type=script&lang=js&"
import style0 from "./AppSpinner.vue?vue&type=style&index=0&id=1a15c518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15c518",
  null
  
)

export default component.exports